import theme from '../../../styles/theme.mjs';
import FlexContainer from '../../Containers/FlexContainer/FlexContainer.mjs';
import styled from 'styled-components';

const StyledCaptions = styled(FlexContainer) `
  display: flex;
  height: max-content;
  width: max-content;
  flex-wrap: wrap;
  white-space: break-spaces;
  color: ${props => props.theme.colors.white};
  background-color: ${props => props.theme.colors.slate}CC;
  text-align: center;
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: ${props => props.theme.typography.fontWeight.regular};
  font-size: ${props => props.isFullScreen
    ? props.theme.typography.text.tiny.fontSize
    : props.theme.typography.text.small.fontSize};

  @media screen and (min-width: ${theme.breakpoints.md}) {
    font-size: ${props => props.isFullScreen
    ? props.theme.typography.headings.h3.fontSize
    : props.theme.typography.text.regular.fontSize};
  }
`;

export { StyledCaptions };
//# sourceMappingURL=Captions.styles.mjs.map
